import { Fragment, useEffect, useRef, useState } from "react";
import {
  addSubCategories,
  createAccounts,
  deleteCategories,
  deleteSubCategories,
  editCategoryName,
  editSubcategory,
} from "../../homepurchase.service";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { getSessionUserInformation } from "app/utils/utility.service";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { formatDate } from "app/utils/utility.service";
import { formatNumber } from "app/utils/utility.service";
import { NumericFormat } from "react-number-format";
import { FormatAmount } from "app/utils/utility.service";
import { formatNumberWithCommas } from "app/utils/utility.service";

const EditAccounts = ({
  editAssetsModal,
  handleEditAssetsModal,
  categories,
  setCategories,
  selCategory,
  setSelCategory,
  fetchAccounts,
  title
}) => {
  const toast = useRef();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [exists, setExists] = useState(false);
  const [searchParams] = useSearchParams();
  const [values, setValues] = useState();
  const sessionValues = getSessionUserInformation();
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [isCategoryEdited, setIsCategoryEdited] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [isSubCategoryEdited, setIsSubCategoryEdited] = useState(false);
  const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
  const [editingId, setEditingId] = useState(null);
  const [tempRow, setTempRow] = useState(null); // backup for Cancel
  const [accounts, setAccounts] = useState([selCategory?.subcategories]);
  const [originalRow, setOriginalRow] = useState(null);
  const [rows, setRows] = useState([]);

  // Load subcategories into "rows" whenever category changes
  useEffect(() => {
    if (selCategory?.subcategories) {
      // deep copy — IMPORTANT
      setRows(JSON.parse(JSON.stringify(selCategory.subcategories)));
    }
  }, [selCategory]);

  const onHide = () => {
    setFormSubmitted(false);
    handleEditAssetsModal(selCategory, title);
    fetchAccounts();
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const validateInput = () => {
    if (!values.name) {
      return false;
    }
    return true;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleEdit = (category) => {
    let name = category.account_name ? category.account_name : category.name;
    setValues({
      ...values,
      name: name,
      id: category.id,
    });
  };
  const updateSubcategoryNameInCategories = (
    categoryId,
    subcategoryId,
    newName
  ) => {
    setCategories((prevCategories) =>
      prevCategories.map((cat) => {
        if (cat.account_id !== categoryId) return cat;

        // Update the matching subcategory's name
        const updatedSubcategories = cat.subcategories.map((sub) =>
          sub.id === subcategoryId ? { ...sub, name: newName, isRealEstateProperty:true } : sub
        );

        return {
          ...cat,
          subcategories: updatedSubcategories,
        };
      })
    );
  };
  const removeSubcategory = (categoryId, subcategoryId) => {
    setCategories((prevCategories) =>
      prevCategories.map((cat) => {
        if (cat.account_id !== categoryId) return cat;

        const updatedSubcategories = cat.subcategories.filter(
          (sub) => sub.id !== subcategoryId
        );

        return {
          ...cat,
          subcategories: updatedSubcategories,
        };
      })
    );
    const updatedSelCategory = {
      ...selCategory,
      subcategories: selCategory.subcategories.filter(
        (sub) => sub.id !== subcategoryId
      ),
    };

    setSelCategory(updatedSelCategory);
  };
  const removeCategory = (categoryId) => {
    setCategories((prevCategories) =>
      prevCategories.filter((cat) => cat.categoryId !== categoryId)
    );
  };
  //Delete sub category
  const handleDelete = async (category) => {
    let details = await deleteSubCategories(category.id);
    if (details) {
      showSuccess("Account deleted successfully");
    }
    removeSubcategory(selCategory.account_id, category.id);
    //await fetchAccounts();
  };
  //Delete category
  const handleDeleteCategories = async (category) => {
    let details = await deleteCategories(category.account_id);
    if (details) {
      showSuccess("Category deleted successfully");
    } else {
      showError(details?.message);
    }
    removeCategory(selCategory.account_id);
    setTimeout(() => {
      onHide();
    }, 1000);
  };
  const handleSubmit = async (e, type) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      return false;
    }

    let details;

    let req = values;
    req.userId = userId;
    req.account_id = selCategory.account_id;
    req.account_name = selCategory.account_name;
    req.type = type;
    if (req.id != null) req.id = values.id;
    let updatedSelCategory;
    //If main category name is edited
    if (isCategoryEdited) {
      req.account_name = values.name;
      const exists = categories.some(
        (category) =>
          category.account_name.toLowerCase() ===
          values.account_name.toLowerCase()
      );
      if (exists) {
        setExists(true);
        return false;
      } else {
        setExists(false);
      }
      setIsLoading(true);
      details = await editCategoryName(selCategory.account_id, req);
      setCategories((prevCategories) =>
        prevCategories.map((cat) =>
          cat.categoryId === selCategory.account_id
            ? { ...cat, account_name: values.name }
            : cat
        )
      );
      updatedSelCategory = selCategory.subcategories.map((sub) =>
        sub.id === values.id ? { ...sub, name: values.name } : sub
      );
      updateSubcategoryNameInCategories(
        selCategory.account_id,
        values.id,
        values.name
      );
      setSelCategory(updatedSelCategory);
      setTimeout(() => {
        onHide();
      }, 1000);
    } else {
      //Add/edit sub categories
      const exists = selCategory.subcategories.some(
        (acc) => acc.name.toLowerCase() === values.name.toLowerCase()
      );
      if (exists) {
        setExists(true);
        return false;
      }
      setIsLoading(true);
      details = await addSubCategories(req);
      updateSubcategoryNameInCategories(
        selCategory.account_id,
        details.id,
        details.name
      );
      //Add sub category
      if (!isSubCategoryEdited) {
        if (details) showSuccess("Account added successfully");
        else showError(details?.message);
        updatedSelCategory = {
          ...selCategory,
          subcategories: [
            ...(selCategory.subcategories || []),
            {
              id: details.id,
              name: details.name,
              value: Number(details.value) ? Number(details.value) : "",
              isRealEstateProperty:true,
              isStatic: false,
            },
          ],
        };

        setSelCategory(updatedSelCategory);
      } else {
        //Edit sub category
        if (details) showSuccess("Account edited successfully");
        else showError(details?.message);
        const updatedSubcategories = selCategory.subcategories.map((sub) =>
          sub.id === values.id ? { ...sub, name: values.name } : sub
        );

        const updatedSelCategory = {
          ...selCategory,
          subcategories: updatedSubcategories,
        };

        setSelCategory(updatedSelCategory);
      }

      setTimeout(() => {
        setIsSubCategoryEdited(false);
        setFormSubmitted(false);
        setIsLoading(false);
        setValues({
          name: "",
        });
        if (!isSubCategoryEdited) {
          fetchAccounts();
        }
      }, 1000);
    }

    setIsLoading(false);
  };
  // Start editing
  const startEdit = (row) => {
    setEditingId(row.id);
    setTempRow({ ...row }); // copy row for edit
    setOriginalRow({ ...row }); // for cancel
    setSaveButtonDisabled(false);
  };

  // Cancel edit
  const cancelEdit = () => {
    console.log(" ori " + JSON.stringify(originalRow));
    if (editingId !== null && originalRow) {
      setRows(JSON.parse(JSON.stringify(selCategory.subcategories)));
    }
    setEditingId(null);
    setTempRow(null);
    setOriginalRow(null);
    setSaveButtonDisabled(true);
  };

  // Editable text field renderer
  const editableText = (row, field) => {
    if (row.isStatic && field === "name") {
      return <span>{row[field]}</span>;
    }
    let prefix = "$ ";
    let suffix = " %";
    if (field === "annualGrowth" || field === "annualIncome") {
      prefix = "";
    } else if (field == "value") {
      suffix = "";
    } else if (field == "name") {
      prefix = "";
      suffix = "";
    }
    if (editingId === row.id) {
      if (field == "name") {
        return (
          <InputText
            value={row[field]}
            style={{"maxWidth":"80px"}} maxLength={50}
            className="editable-input"
            onChange={(e) => updateField(row.id, field, e.target.value)}
          />
        );
      } else {
        return (
          <NumericFormat 
            value={row[field]}
            className="input-field"
            onValueChange={(e) => updateField(row.id, field, e.value)}
            locale="en-US"
            mode="decimal"
            useGrouping={true}
            prefix={prefix}
            thousandSeparator=","
            suffix={suffix}
            allowNegative={false}
            decimalScale={2}
            
          />
        );
      }
    }
    
    if (field === "value") 
      return row[field] ? `${prefix}${formatNumberWithCommas(row[field])}${suffix}` : "";
    else if(field == "annualIncome" || field == "annualGrowth")
       return row[field] ? `${prefix}${(row[field])}${suffix}` : "";
    else
      return row[field] ? row[field] : "";
  };

  // Editable text field renderer
  const editableDate = (row, field) => {
    if (editingId === row.id) {
      return (
        <Calendar
          id="buttondisplay"
          onChange={(e) => updateField(row.id, field, e.target.value)}
          value={
            row?.purchaseDate ? new Date(formatDate(row.purchaseDate)) : ""
          }
          showIcon
          dateFormat="mm/dd/yy"
          style={{ width: "180px" }}
        />
      );
    }
    return row[field] ? formatDate(row[field]) : "";
  };

  // Save edit
  const saveEdit = async (category) => {
    // Push edited rows into selected category
    const updatedCategory = {
      ...selCategory,
      subcategories: rows,
    };

    // Update selected category state
    setSelCategory(updatedCategory);
    // setTimeout(() => {
    /* setCategories(prev =>
      prev.map(cat =>
        cat.id === updatedCategory.id ? updatedCategory : cat
      )
    );*/
    //Update main categories array with updated sub category values
    setCategories((prev) =>
      prev.map((cat) =>
        cat.id === selCategory.id
          ? {
              ...cat,
              subcategories: cat.subcategories.map((sc) =>
                sc.id === tempRow.id ? { ...tempRow } : sc
              ),
            }
          : cat
      )
    );
    let details = saveAccounts(updatedCategory);
    //}, 1000);
    // Exit edit mode
    setEditingId(null);
  };

  const saveAccounts = async (category) => {
    const updatedCategory = {
      ...tempRow,
    };

    updatedCategory.userId = userId;
    updatedCategory.type = title;
    updatedCategory.account_name = category.account_name;
    let details = await editSubcategory(updatedCategory.id, updatedCategory);
    if (details) {
      showSuccess("Account updated successfully");
    }
  };

  // Update field
  const updateField = (id, field, value) => {
    setRows((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        const updatedRow = { ...item, [field]: value };

        if (field == "purchaseDate" && value != null) {
          updatedRow.purchaseDate = new Date(
            Date.UTC(value?.getFullYear(), value?.getMonth(), value?.getDate())
          )
            .toISOString()
            .split("T")[0];
        }
        /*if (field === "value" || field === "annualGrowth") {
          // get clean numbers from updated row
          const amount = parseFloat(updatedRow.value);
          const growth = parseFloat(updatedRow.annualGrowth);

          // auto-calculate
          if (!isNaN(amount) && !isNaN(growth)) {
            updatedRow.annualIncome = amount * (growth / 100);
          } else {
            updatedRow.annualIncome = "";
          }
        }*/
        // also update temp row (if you use it)
        setTempRow(updatedRow);

        return updatedRow;
      })
    );
  };
  const onReinvestChange = (checked, index, row) => {
    // Build updated row
    const updated = {
      ...row,
      reinvest: checked,
    };
    setTempRow(updated);
    // Update rows
    setRows((prev) => prev.map((r) => (r.id === row.id ? updated : r)));
  };
  // Editable Yes/No radio buttons
  const reinvestTemplate = (rowData, rowIndex) => {
    //  if (editingId === row.id) {
    if(((selCategory.account_name == categories[1].account_name && !["Stocks", "Commodities", "Cryptocurrency"].includes(rowData.name)) ||
     (selCategory.account_name == categories[3].account_name && rowData.isRealEstateProperty) ||
      (selCategory.account_name == categories[0].account_name ||  selCategory.account_name == categories[2].account_name
        ||selCategory.account_name == categories[4].account_name) || rowData.isRealEstateProperty )
      ) {
    return (
      <div className="flex gap-3">
        <div className="flex gap-1 align-items-center checkboxEdit">
       
          <Checkbox
            inputId="yes"
            className="custom-red-checkbox"
            onChange={(e) => onReinvestChange(e.checked, rowIndex, rowData)}
            checked={!!rowData.reinvest}
            disabled={editingId !== rowData.id}
           
          />
        </div>

        {/*<div className="flex gap-1 align-items-center">
                        <RadioButton
                            inputId={`no-${row.id}`}
                            name={`reinvest-${row.id}`}
                            value="No"
                            checked={row.reinvest === "No"}
                            onChange={(e) => updateField(row.id, "reinvest", e.value)}
                        />
                        <label htmlFor={`no-${row.id}`}>No</label>
                    </div> */}
      </div>
    );
  }

    //  return row.reinvest;
  };
  const canEnableTick = (rowData) => {
    return (
      rowData.amount &&
      rowData.purchaseDate &&
      rowData.annualGrowth &&
      rowData.amount !== "" &&
      rowData.annualGrowth !== ""
    );
  };
  // Action icons (Edit / Save + Cancel)
  const actionTemplate = (row) => {
    const disableSave = (!row.value || row.value == 0) || !row.purchaseDate || !row.annualGrowth || !row.annualIncome;
   
    if (editingId === row.id) {
      if(disableSave) setSaveButtonDisabled(true);
      else setSaveButtonDisabled(false);
      return (
        <div className="flex gap-3">
         {/*} <i
            className={`pi pi-check cursor-pointer button-color ${
              disableSave ? "disabled-icon" : ""
            }`}
            onClick={disableSave ? undefined : saveEdit}

          ></i>*/}
          <i
            className="pi pi-times disableSavecursor-pointer button-color"
            onClick={cancelEdit}
          ></i>
        </div>
      );
    }

    if(((selCategory.account_name == categories[1].account_name && ![categories[1].subcategories[0].name].includes(row.name)) ||
     (selCategory.account_name == categories[3].account_name && row.isRealEstateProperty) ||
      (selCategory.account_name == categories[0].account_name ||  selCategory.account_name == categories[2].account_name
        ||selCategory.account_name == categories[4].account_name)) ||  selCategory?.subcategories?.some(
  (item) => item.isRealEstateProperty )
      ){
      return (
        
        <Fragment>
          <Button
            icon="pi pi-pencil"
            className="p-button-text ml-4"
            style={{ boxShadow: "none" }}
            onClick={() => startEdit(row)}
            disabled={editingId}
          ></Button>
         {!row.isStatic && (
          <Button
            icon="pi pi-trash"
            className="p-button-text ml-4"
            style={{ boxShadow: "none" }}
            onClick={(e) => {
              e.stopPropagation(); // prevents accordion toggle
              e.preventDefault();
              handleDelete(row);
            }}
          ></Button>
        )}
        </Fragment>
      );
    
    };
  };

  return (
    <Dialog
      header={`Manage Accounts - ${selCategory.account_name}`}
      visible={editAssetsModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{
        width: title === "Assets" ? "85vw" : "50vw", //width based on condition
      }}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align" style={{ margin: "2rem" }}>
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid">
              <div className={`${isDesktopOrLaptop ? "col-4" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <InputText
                        maxLength={50}
                        placeholder="Add new investment account"
                        className="vw-inputtext-with-border custom-placeholder"
                        autoComplete="off"
                        required={true}
                        name="name"
                        value={values?.name}
                        onChange={handleInputChange}
                      />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.name && (
                      <small className="p-error">
                        Please enter account field name
                      </small>
                    )}
                    {formSubmitted && values?.name && exists && (
                      <small className="p-error">Name already exists</small>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-1">
                <Button
                  type="submit"
                  label="Add"
                  className={`p-button-raised p-button-warning p-button-lg  ${
                    isDesktopOrLaptop ? "ml-6" : "ml-4"
                  }`}
                  onClick={(e) => handleSubmit(e, title)}
                />
              </div>
            </div>
          </div>
          {/*<div
            className="flex flex-col gap-3 p-1"
            style={{ alignItems: "center" }}
          >
             <div className="font-bold mb-2 col-6" style={{color:"#6c757d"}}>
              {selCategory?.account_name}
            </div>
            <div className="col-5">
              {!selCategory.isStatic && (
                <Fragment>
                  <Button
                    className="p-button-text"
                    style={{ boxShadow: "none" }}
                    icon="pi pi-pencil"
                    onClick={(e) => {
                      e.stopPropagation(); // prevents accordion toggle
                      e.preventDefault();
                      handleEdit(selCategory);
                      setIsCategoryEdited(true);
                    }}
                  ></Button>
                  <Button
                    icon="pi pi-trash"
                    className="p-button-text ml-4"
                    style={{ boxShadow: "none" }}
                    onClick={(e) => {
                      e.stopPropagation(); // prevents accordion toggle
                      e.preventDefault();
                      handleDeleteCategories(selCategory);
                    }}
                  ></Button>
                </Fragment>
              )}
            </div>
          </div> */}
          
          {title == "Assets" ? (
          <div className="card">
            <DataTable
              value={rows}
              dataKey="id"
              className="accounts-table"
              tableStyle={{ tableLayout: "fixed" }}
            >
              <Column
                header={`${selCategory.account_name}`}
                body={(row) => editableText(row, "name")}
                style={{ width: "180px" }}
              />

              <Column
                header="Acquisition Price"
                body={(row) => editableText(row, "value")}
                style={{ width: "180px" }}
              />

              <Column
                header="Purchase Date"
                body={(row) => editableDate(row, "purchaseDate")}
                style={{ width: "180px" }}
              />

              <Column
                header="Annual Growth"
                body={(row) => editableText(row, "annualGrowth")}
                style={{ width: "180px" }}
              />

              <Column
                header="Annual Income"
                body={(row) => editableText(row, "annualIncome")}
                style={{ width: "180px" }}
              />

              <Column
                header="Reinvest"
                body={(rowData, options) =>
                  reinvestTemplate(rowData, options.rowIndex)
                }
              />

              <Column
                header="Action"
                body={actionTemplate}
                style={{ width: "180px" }}
              />
            </DataTable>
            <div className="col-5">
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg mt-6"
              onClick={() => onHide()}
            />
            
            <Button
              label="Save"
              className="p-button-raised p-button-warning p-button-lg mt-6 ml-4"
              disabled={saveButtonDisabled}
              onClick={() => saveEdit()}
            />
            </div>
          </div>
          
          ) :
         title == "Liabilities" ? (
            selCategory?.subcategories?.map((subcat, index) => (
            <div
              key={subcat.id}
              className="flex flex-col gap-3 p-1"
              style={{ alignItems: "center" }}
            >
              <div className="col-6">
                <span style={{ wordWrap: "break-word" }}>{subcat?.name}</span>
              </div>
              <div className="col-5">
                {  ( (selCategory.account_name == categories[1].account_name && 
                subcat.name !== categories[1].subcategories[0].name && subcat.isRealEstateProperty == 1) ||
               subcat.isRealEstateProperty === 1)
                && (
                  <Fragment>
                    <Button
                    icon="pi pi-pencil"
                    className="p-button-text"
                    style={{ boxShadow: "none" }}
                    onClick={(e) => {
                      e.stopPropagation(); // prevents accordion toggle
                      e.preventDefault();
                      handleEdit(subcat);
                      setIsCategoryEdited(false);
                      setIsSubCategoryEdited(true);
                    }}
                  ></Button>
                    
                    <Button
                    icon="pi pi-trash"
                    className="p-button-text ml-4"
                    style={{ boxShadow: "none" }}
                    onClick={(e) => {
                      e.stopPropagation(); // prevents accordion toggle
                      e.preventDefault();
                      handleDelete(subcat);
                    }}
                  ></Button>
                 
                  </Fragment>
                )}
              </div>
            </div>
          ))
        
      ) : null}

          
        </div>
      </div>
    </Dialog>
  );
};
export default EditAccounts;
